import Dashboard_Admin from "components/Admin/Inicio-Admin/Dashboard_Admin";
import React from "react";
import GenerarHojaVida from "./Hoja de Vida/GenerarHojaVida";
import Solicitud_Certificados from "./Solicitud Certificados/Solicitud_Certificados";
import PlanificacionVacaciones from "./Vacaciones/Planificacion Vacaciones/PlanificacionVacaciones";
import SolicitudVacaciones from "./Vacaciones/Solicitud Vacaciones/SolicitudVacaciones";
import DatosBancarios from "./Datos Bancarios/DatosBancarios";
import SolicitudAcumulaDecimos from "./Solicitud Acumula Decimos/SolicitudAcumulaDecimos";
import FormularioGastosPersonales from "./Formulario Gastos Personales/FormularioGastosPersonales";
import AcuerdoMediosElectronicos from "./Acuerdo Medios Electronicos/AcuerdoMediosElectronicos";
import RegistroEntradaSalidaAlmuerzo from "./Registro Entrada Salida/RegistroEntradaSalidaAlmuerzo";
import HistorialMarcaciones from "./Registro Entrada Salida/HistorialMarcaciones";
import SolicitudPermisos from "./Permisos/Solicitud Permisos/SolicitudPermisos";
import HistorialPermisos from "./Permisos/Historial Permisos/HistorialPermisos";
import NotificacionEmbarazo from "./NotificacionEmbarazo/NotificacionEmbarazo";
import SolicitudCambioHorario from "./Solicitud Cambio Horario/SolicitudCambioHorario";
import Formulario107 from "./Formulario107/Formulario107";
import { ROUTE_HOJA_MARCACIONES } from "Context/SideBarContext";
import HojaMarcaciones from "./Hoja Marcaciones/HojaMarcaciones";
import SolicitudPagoHE from "./HorasExtras/SolicitudPagoHE/SolicitudPagoHE";
import InicioHE from "./HorasExtras/InicioHe/InicioHE";
import HojaMarcacionesServidor from "./Hoja Marcaciones/HojaMarcacionesServidor";
import DocumentosEntregar from "./Vinculacion/DocumentosEntregar";

const layout = "/web";

const USUARIOS_ROUTES: Array<{ path: string, component: any,layout:string}> = [
   
    {
        path: "/planificacion_vacaciones",
        component: PlanificacionVacaciones,
        layout,
    },
    {
        path: "/solicitud_vacaciones",
        component: SolicitudVacaciones,
        layout,
    },
    {
        path: "/solicitud_permisos_licencias",
        component: SolicitudPermisos,
        layout,
    },
    {
        path: "/historial_permisos_licencias",
        component: HistorialPermisos,
        layout,
    },
    {
        path: "/notificacion_embarazo",
        component: NotificacionEmbarazo,
        layout,
    },
    {
        path: "/solicitud_cambio_horario",
        component: SolicitudCambioHorario,
        layout,
    },
    {
        path: "/solicitud_certificado",
        component: Solicitud_Certificados,
        layout,
    },
    {
        path: "/generarHojaVida",
        component: GenerarHojaVida,
        layout,
    },
    {
        path: "/datos_bancarios",
        component: DatosBancarios,
        layout,
    },
    {
        path: "/solicitud_acumula_decimos",
        component: SolicitudAcumulaDecimos,
        layout,
    },
    {
        path: "/formulario_gastos_personales",
        component: FormularioGastosPersonales,
        layout,
    },
    {
        path: "/acuerdo_medios_electronicos",
        component: AcuerdoMediosElectronicos,
        layout,
    },
    {
        path: `${ROUTE_HOJA_MARCACIONES.split(layout)[1]}`,
        component: HojaMarcacionesServidor,
        layout,
    },
    {
        path: "/historial_marcaciones",
        component: HistorialMarcaciones,
        layout,
    },
    {
        path: "/registro_recesoalmuerzo",
        component: RegistroEntradaSalidaAlmuerzo,
        layout,
    },
     {
         path: "/horasextras",
         component: InicioHE,
         layout: "/web",
     },
     {
         path: "/solicitud_pago_horas_extras",
         component: SolicitudPagoHE,
         layout: "/web",
     }
     ,
    {
        path: "/formulario_107",
        component: Formulario107,
        layout,
    },

    {
        path: "/vinculacion",
        component: DocumentosEntregar,
        layout: "/web",
    },
    {
        path: "",
        component: Dashboard_Admin,
        layout,
    },

];
export default USUARIOS_ROUTES;
